import { environment } from '../../environments/environment';

export class AppSettings {
    
    public static API_ENDPOINT = environment.APIEndpoint;
    public static API_KEY = '5ec46c474abfb8eed65336a939e10589';
    public static API_KEY_FIELD = 'X-API-KEY';
    public static SITE_TITLE = 'KAIZENCLOUD';
    public static LOGO = AppSettings.API_ENDPOINT+'assets/images/logo.png';
    public static LOGIN_BACK = AppSettings.API_ENDPOINT+'assets/images/login_back.jpg';
    
 }
